import React, { useEffect, useRef, useState } from "react";
// import { getResults } from '../../services/results/resultsService';
import { postFinalResultsFiles } from "../../../../../../services/olympiad/resultsFilesService";
import { Button } from "../../../../../../components/forms/Buttons/Button";
import CustomDialog from "../../../../../../components/modals/CustomDialog/CustomDialog";
import Select from "../../../../../../components/forms/Select/Select";
import { ArrowUpTrayIcon } from "@heroicons/react/24/solid";
// import useSnackbar from '../../../../utils/hooks/useSnackbar';

export default function CREATE({ onCreate }) {
  // const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [open, setOpen] = useState(false);
  // const { addSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [level, setLevel] = useState(null);
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const inputRef = useRef(null);

  const onClose = () => {
    setLevel(null);
    setFile(null);
    setFileError(null);
    setOpen(false);
  };

  useEffect(() => {
    return () => {
      setFile(null);
      setFileError(null);
    };
  }, []);

  return (
    <>
      <Button text="Upload" onClick={() => setOpen(true)} />
      <CustomDialog
        isOpen={open}
        closeModal={() => {
          onClose();
        }}
      >
        <input
          className="border"
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          ref={inputRef}
          onChange={(e, d) => {
            setFile(e.target.files[0]);
            // e.target.value = null;
          }}
        />
        <Select
          className="z-20"
          value={level}
          isSearchable={false}
          options={[1].map((v, i) => ({
            label: `${v} тур`,
            value: `${v}`,
          }))}
          placeholder="Тур"
          onChange={(e) => {
            console.log(e.value);
            setLevel(e.value);
          }}
        />
        <Button
          Icon={ArrowUpTrayIcon}
          color="primary"
          className="h-9"
          text="Файлды жіберу"
          loading={loading}
          onClick={() => {
            if (level !== null && file) {
              setLoading(true);
              const body = new FormData();
              body.append("file", file);
              body.append("level", level);

              postFinalResultsFiles(body)
                .then((res) => {
                  if (onCreate) {
                    onCreate(res);
                  }
                  onClose();
                })
                // .catch(() => {
                //   addSnackbar(t('Ошибка'), 'error');
                // })
                .finally(() => {
                  setLoading(false);
                  setFile(null);
                  inputRef.current.value = null;
                  setLevel(null);
                });
            }
            if (file === null) {
              // addSnackbar('Файлды таңдаңыз', 'error');
            } else if (level === null) {
              // addSnackbar('Турды / ӘОТ таңдаңыз', 'error');
            }
          }}
        />
      </CustomDialog>
    </>
  );
}
